import { AbstractControl, ValidatorFn } from '@angular/forms';

export class NumberValidator {
  static maxLength(maxLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (value != null && value.toString().length > maxLength) {
        return {
          maxLengthNumber: {
            requiredLength: maxLength,
            actualLength: value.toString().length
          }
        };
      }

      return null;
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/validators-forms/max-length-number.validator.helper.ts